// @ts-nocheck
import common from "@store/Themes/common/styleguide/components/forms/formField";
import { sasInputStyles } from "@store/Themes/sas/mixins/formField";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const formField: Styleguide["formField"] = {
    defaultProps: {
        ...common?.defaultProps,
        labelProps: {
            css: css`
                ${({ theme }) => css`
                    ${common?.defaultProps?.labelProps?.css}
                    font-weight: ${theme.design.typography.weight.medium};
                `}
            `,
        },
        hintProps: {
            ...common?.defaultProps?.hintProps,
            color: "text.input",
        },
        cssOverrides: {
            ...common?.defaultProps?.cssOverrides,
            formField: css`
                textarea {
                    ${sasInputStyles()}
                    border-radius: ${pxToRem(2)};
                }
            `,
            inputSelect: css`
                ${sasInputStyles()}
            `,
            descriptionWrapper: css`
                ${common?.defaultProps?.cssOverrides?.descriptionWrapper}
                ${({ theme }) => css`
                    font-weight: ${theme.design.typography.weight.base};
                `}
            `,
        },
    },
};

export default formField;
